import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Activity, Crown, LogOut, Users } from "lucide-react";
import { Login } from "@/pages/Analytics";
import { AdminShell, CreatorsPanel } from "@/pages/AdminCreators";
import CreatorActivity from "@/components/CreatorActivity";
import PremiumPasses from "@/components/PremiumPasses";
import BulkPasses from "@/components/BulkPasses";

const KEY = "astra_analytics_token";
const TABS = [["activity", "Creator activity", Activity], ["creators", "Creators", Users], ["passes", "Premium passes", Crown]];

export default function AdminHub() {
  const [token, setToken] = useState(() => sessionStorage.getItem(KEY));
  const [params, setParams] = useSearchParams();
  const tab = TABS.some(([id]) => id === params.get("tab")) ? params.get("tab") : "activity";
  const setTab = (id) => setParams(id === "activity" ? {} : { tab: id });
  useEffect(() => { window.scrollTo(0, 0); }, [tab]);
  const [passKey, setPassKey] = useState(0);
  const expire = useCallback(() => { sessionStorage.removeItem(KEY); setToken(null); }, []);
  if (!token) return <AdminShell testId="admin-hub"><Login onToken={setToken} /></AdminShell>;
  return (
    <AdminShell testId="admin-hub">
      <header className="flex flex-wrap items-center gap-3 mb-6">
        <div><p className="text-[11px] uppercase tracking-[0.3em] gold-text">Astra · Private</p><h1 className="text-3xl font-light">Admin</h1></div>
        <a href="/analytics" data-testid="admin-hub-analytics" className="ml-auto text-sm gold-text underline underline-offset-4">Full analytics</a>
        <button data-testid="admin-hub-logout" onClick={expire} aria-label="Sign out" className="text-[#A7B0C0] hover:text-starlight"><LogOut size={16} /></button>
      </header>
      <nav className="flex gap-2 mb-6 overflow-x-auto" role="tablist">
        {TABS.map(([id, label, Icon]) => (
          <button key={id} role="tab" aria-selected={tab === id} data-testid={`admin-tab-${id}`} onClick={() => setTab(id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors ${tab === id ? "bg-[#D4AF37] text-[#04060B]" : "border border-[#D4AF37]/30 text-[#D6D0C5] hover:border-[#D4AF37]"}`}>
            <Icon size={15} /> {label}
          </button>
        ))}
      </nav>
      {tab === "activity" && <CreatorActivity token={token} onExpired={expire} />}
      {tab === "creators" && <CreatorsPanel token={token} onExpired={expire} title="" />}
      {tab === "passes" && (
        <>
          <BulkPasses token={token} onSent={() => setTimeout(() => setPassKey((k) => k + 1), 2000)} />
          <PremiumPasses key={passKey} token={token} />
        </>
      )}
    </AdminShell>
  );
}
